import Layout from '@recept-pc-sdk/layouts/index.tsx';
import { lazy } from 'ice';
import NotFound from './component/NotFound';

const Authconfirm = lazy(
  () => import(/* webpackChunkName: 'AuthConfirm' */ '@recept-pc-sdk/pages/accept/AuthConfirm'),
);
const Condition = lazy(
  () => import(/* webpackChunkName: 'Condition' */ '@recept-pc-sdk/pages/accept/Condition'),
);
const CorrectionEntry = lazy(
  () =>
    import(
      /* webpackChunkName: 'CorrectionEntry' */ '@recept-pc-sdk/pages/accept/Correction/entry'
    ),
);
const Entry = lazy(
  () => import(/* webpackChunkName: 'entry' */ '@recept-pc-sdk/pages/accept/entry'),
);
const Facevalidate = lazy(
  () => import(/* webpackChunkName: 'FaceValidate' */ '@recept-pc-sdk/pages/accept/FaceValidate'),
);
const Form = lazy(() => import(/* webpackChunkName: 'Form' */ '@recept-pc-sdk/pages/accept/Form'));
const Infoconfirm = lazy(
  () => import(/* webpackChunkName: 'InfoConfirm' */ '@recept-pc-sdk/pages/accept/InfoConfirm'),
);
const Material = lazy(
  () => import(/* webpackChunkName: 'Material' */ '@recept-pc-sdk/pages/accept/Material'),
);
const Modeselect = lazy(
  () => import(/* webpackChunkName: 'ModeSelect' */ '@recept-pc-sdk/pages/accept/ModeSelect'),
);
const Notice = lazy(
  () => import(/* webpackChunkName: 'Notice' */ '@recept-pc-sdk/pages/accept/Notice'),
);
const Payment = lazy(
  () => import(/* webpackChunkName: 'Payment' */ '@recept-pc-sdk/pages/accept/Payment'),
);
const Receipt = lazy(
  () => import(/* webpackChunkName: 'Receipt' */ '@recept-pc-sdk/pages/accept/Receipt'),
);
const Result = lazy(
  () => import(/* webpackChunkName: 'Result' */ '@recept-pc-sdk/pages/accept/Result'),
);

const BatchResult = lazy(
  () => import(/* webpackChunkName: 'BatchResult' */ '@recept-pc-sdk/pages/accept/BatchResult'),
);

const Sceneguide = lazy(
  () => import(/* webpackChunkName: 'SceneGuide' */ '@recept-pc-sdk/pages/accept/SceneGuide'),
);

/*
  未登陆也可访问
  前置情形引导 https://aone.alibaba-inc.com/v2/project/1006197/task/37830439# 《智能引导式办事指南前端任务》 */
const PreSceneGuide = lazy(
  () => import(/* webpackChunkName: 'PreSceneGuide' */ '@recept-pc-sdk/pages/accept/PreSceneGuide'),
);

const InfoSupplement = lazy(
  () =>
    import(/* webpackChunkName: 'InfoSupplement' */ '@recept-pc-sdk/pages/accept/InfoSupplement'),
);

const InformingCommitment = lazy(
  () =>
    import(
      /* webpackChunkName: 'InformingCommitment' */ '@recept-pc-sdk/pages/accept/InformingCommitment'
    ),
);

const BatchInformingCommitment = lazy(
  () =>
    import(
      /* webpackChunkName: 'BatchInformingCommitment' */ '@recept-pc-sdk/pages/accept/InformingCommitment/batch'
    ),
);

const TradeDetail = lazy(
  () => import(/* webpackChunkName: 'TradeDetail' */ '@recept-pc-sdk/pages/accept/TradeDetail'),
);

const TradeList = lazy(
  () => import(/* webpackChunkName: 'TradeList' */ '@recept-pc-sdk/pages/accept/TradeList'),
);

const TradeRedirect = lazy(
  () => import(/* webpackChunkName: 'TradeRedirect' */ '@recept-pc-sdk/pages/trade/redirect'),
);

const TradePaperReceipt = lazy(
  () => import(/* webpackChunkName: TradePaperReceipt */ '@recept-pc-sdk/pages/trade/PaperReceipt'),
);
const TradeResult = lazy(
  () => import(/* webpackChunkName: TradeResult */ '@recept-pc-sdk/pages/trade/Result'),
);

const TradeCancel = lazy(
  () => import(/* webpackChunkName: TradeCancel */ '@recept-pc-sdk/pages/trade/AcceptCancel'),
);

const TradePayQrCode = lazy(
  () => import(/* webpackChunkName: TradePayQrCode */ '@recept-pc-sdk/pages/trade/PayQrCode'),
);

const TradeMatterResult = lazy(
  () => import(/* webpackChunkName: TradeMatterResult */ '@recept-pc-sdk/pages/trade/MatterResult'),
);

const TradeDeatil = lazy(
  () => import(/* webpackChunkName: TradeDeatil */ '@recept-pc-sdk/pages/trade/Detail'),
);

const TradePayDetail = lazy(
  () => import(/* webpackChunkName: TradePayDetail */ '@recept-pc-sdk/pages/trade/PayDetail'),
);

const PersonalProfile = lazy(
  () => import(/* webpackChunkName: PersonalProfile */ '@recept-pc-sdk/pages/PersonalProfile'),
);
const PersonalProfileAgreement = lazy(
  () =>
    import(
      /* webpackChunkName: PersonalProfileAgreement */ '@recept-pc-sdk/pages/PersonalProfile/agreement'
    ),
);
const Throttle = lazy(
  () => import(/* webpackChunkName: 'Throttle' */ '@recept-pc-sdk/pages/throttle'),
);

const Expire = lazy(() => import(/* webpackChunkName: 'Expire' */ '@recept-pc-sdk/pages/expire'));

export default [
  {
    path: '/',
    exact: false,
    component: Layout,
    children: [
      {
        path: '/accept/authconfirm',
        exact: true,
        component: Authconfirm,
      },
      {
        path: '/accept/condition',
        exact: true,
        component: Condition,
      },
      {
        path: '/accept/correction/entry',
        exact: true,
        component: CorrectionEntry,
      },
      {
        path: '/accept/correction/form',
        exact: true,
        component: Form,
      },
      {
        path: '/accept/correction/material',
        exact: true,
        component: Material,
      },
      {
        path: '/accept/correction/formConfirm',
        exact: true,
        component: Infoconfirm,
      },
      {
        path: '/accept/correction/informingCommitment',
        exact: true,
        component: InformingCommitment,
      },
      {
        path: '/accept/correction/result',
        exact: true,
        component: Result,
      },
      {
        path: '/accept/correction/:id',
        exact: true,
        component: NotFound,
      },
      {
        path: '/accept/infoSupplement',
        exact: true,
        component: InfoSupplement,
      },
      {
        path: '/accept/entry',
        exact: true,
        component: Entry,
      },
      {
        path: '/accept/facevalidate',
        exact: true,
        component: Facevalidate,
      },
      {
        path: '/accept/form',
        exact: true,
        component: Form,
      },
      {
        path: '/accept/infoconfirm',
        exact: true,
        component: Infoconfirm,
      },
      {
        path: '/accept/formConfirm',
        exact: true,
        component: Infoconfirm,
      },
      {
        path: '/accept/material',
        exact: true,
        component: Material,
      },
      {
        path: '/accept/modeselect',
        exact: true,
        component: Modeselect,
      },
      {
        path: '/accept/notice',
        exact: true,
        component: Notice,
      },
      {
        path: '/accept/payment',
        exact: true,
        component: Payment,
      },
      {
        path: '/accept/receipt',
        exact: true,
        component: Receipt,
      },
      {
        path: '/accept/logistics',
        exact: true,
        component: Receipt,
      },
      {
        path: '/accept/result',
        exact: true,
        component: Result,
      },

      {
        path: '/accept/batchresult',
        exact: true,
        component: BatchResult,
      },

      {
        path: '/accept/sceneguide',
        exact: true,
        component: Sceneguide,
      },
      {
        path: '/accept/presceneguide',
        exact: true,
        component: PreSceneGuide,
      },
      {
        path: '/accept/informingCommitment',
        exact: true,
        component: InformingCommitment,
      },
      {
        path: '/accept/batchInformingCommitment',
        exact: true,
        component: BatchInformingCommitment,
      },
      {
        path: '/accept/trade/detail',
        exact: true,
        component: TradeDetail,
      },
      {
        path: '/accept/trade/list',
        exact: true,
        component: TradeList,
      },
      // 办件查询件结果
      {
        path: '/result',
        exact: true,
        component: TradeResult,
      },
      // 办件普通件结果
      {
        path: '/usercenter/MatterResult',
        exact: true,
        component: TradeMatterResult,
      },
      // 办件详情
      {
        path: '/usercenter/detail',
        exact: true,
        component: TradeDeatil,
      },
      // 办件转跳
      {
        path: '/usercenter/redirect',
        exact: true,
        component: TradeRedirect,
      },
      // 办件文书确认
      {
        path: '/usercenter/paperreceipt',
        exact: true,
        component: TradePaperReceipt,
      },
      // 办件撤回
      {
        path: '/usercenter/acceptcancel',
        exact: true,
        component: TradeCancel,
      },
      // 办件支付二维码
      {
        path: '/usercenter/payqrcode',
        exact: true,
        component: TradePayQrCode,
      },
      // 支付
      {
        path: '/usercenter/paydetail',
        exact: true,
        component: TradePayDetail,
      },
      // 个人档案
      {
        path: '/personalprofile',
        exact: true,
        component: PersonalProfile,
      },
      // 个人档案 查看协议
      {
        path: '/personalprofile/agreement',
        exact: true,
        component: PersonalProfileAgreement,
      },
      {
        path: '/throttle',
        exact: true,
        component: Throttle,
      },
      {
        path: '/expire',
        exact: true,
        component: Expire,
      },
      {
        component: NotFound,
      },
    ],
  },
];
